/** Panduan perakitan, dari video tutorial Kanata
 *  (youtube.com/watch?v=hRFtmNA1cMY). Bahasa Indonesia, kamu.
 *
 *  Part names stay English because that is what is printed on the parts and in
 *  the box — translating them would leave the reader matching a word to a
 *  label that says something else. */

export const assemblyVideo = {
  id: "hRFtmNA1cMY",
  url: "https://www.youtube.com/watch?v=hRFtmNA1cMY",
  /** Durasi video tutorial, menit. */
  videoMinutes: 4,
  /** Perkiraan waktu rakit sebenarnya. */
  estimatedMinutes: 20,
};

export interface Part {
  n: number;
  name: string;
  qty: number;
  note?: string;
}

/** Isi dus. */
export const parts: Part[] = [
  { n: 1, name: "Bottom Feet", qty: 2 },
  { n: 2, name: "Left Leg", qty: 1 },
  { n: 3, name: "Right Leg", qty: 1, note: "berisi motor" },
  { n: 4, name: "Center Rail", qty: 1 },
  { n: 5, name: "Rotating Bar", qty: 1 },
  { n: 6, name: "Side Bracket", qty: 2 },
  { n: 7, name: "Power Supply", qty: 1 },
  { n: 8, name: "Handset", qty: 1 },
  { n: 9, name: "Power Pallet", qty: 1 },
  { n: 10, name: "Power Cord", qty: 1 },
  { n: 11, name: "Power Socket", qty: 1 },
];

export interface Screw {
  code: string;
  spec: string;
  qty: number;
}

export const screws: Screw[] = [
  { code: "A", spec: "Baut M6×14", qty: 16 },
  { code: "B", spec: "Baut M6×10", qty: 4 },
  { code: "C", spec: "Sekrup ST4.2", qty: 14 },
  { code: "D", spec: "Kunci pas", qty: 1 },
  { code: "E", spec: "Kunci L (2,5 & 5)", qty: 1 },
];

export const tools = [
  "Obeng elektrik atau bor (disarankan)",
  "Kunci pas bawaan (D)",
  "Kunci L bawaan (E)",
  "Satu orang lagi untuk bantu membalik meja (disarankan)",
];

export interface AssemblyStep {
  n: number;
  title: string;
  description: string;
  /** Baut/alat yang dipakai, mis. "A" (cocok dengan screws[].code). */
  screw?: string;
  imageKey: string;
}

export const assemblySteps: AssemblyStep[] = [
  {
    n: 1,
    title: "Tata rangkanya",
    description:
      "Letakkan kaki kiri dan kaki kanan di sisi center rail, masing-masing di sisi yang benar.",
    imageKey: "step-01",
  },
  {
    n: 2,
    title: "Pasang kaki ke center rail",
    description: "Kencangkan tiap kaki ke center rail pakai baut A (M6×14).",
    screw: "A",
    imageKey: "step-02",
  },
  {
    n: 3,
    title: "Pasang bottom feet",
    description: "Sambungkan satu bottom foot ke dasar tiap kaki, pakai baut A lagi.",
    screw: "A",
    imageKey: "step-03",
  },
  {
    n: 4,
    title: "Berdirikan rangkanya",
    description: "Balik rangka yang sudah jadi supaya berdiri di atas kakinya.",
    imageKey: "step-04",
  },
  {
    n: 5,
    title: "Pasang rangka ke tabletop",
    description:
      "Telungkupkan tabletop, lalu taruh rangkanya di bagian belakang. Luruskan rangka dengan titik penanda di sisi kiri dan kanan papan.",
    imageKey: "step-05",
  },
  {
    n: 6,
    title: "Gantung power pallet",
    description:
      "Kaitkan power pallet ke rangka kaki, di sebelah kaki yang berisi motor (kaki kanan).",
    imageKey: "step-06",
  },
  {
    n: 7,
    title: "Kencangkan side bracket",
    description: "Kunci side bracket tiap kaki ke tabletop pakai sekrup C. Ulangi di kedua sisi.",
    screw: "C",
    imageKey: "step-07",
  },
  {
    n: 8,
    title: "Kencangkan center rail",
    description: "Pasang center rail ke tabletop pakai sekrup C.",
    screw: "C",
    imageKey: "step-08",
  },
  {
    n: 9,
    title: "Kunci posisi rail",
    description:
      "Setelah center rail ada di kedalaman yang pas, kunci mati pakai baut B (M6×10).",
    screw: "B",
    imageKey: "step-09",
  },
  {
    n: 10,
    title: "Pasang handset",
    description:
      "Pasang handset (kotak kontrol) ke tabletop pakai sekrup C, posisinya tepat di depan power pallet.",
    screw: "C",
    imageKey: "step-10",
  },
  {
    n: 11,
    title: "Sambungkan rotating bar",
    description:
      "Pastikan rotating bar tersambung di sisi kanan, lalu kencangkan dengan tangan atau kunci pas (D).",
    screw: "D",
    imageKey: "step-11",
  },
  {
    n: 12,
    title: "Berdirikan mejanya",
    description: "Balik mejanya pelan-pelan supaya berdiri di atas kakinya.",
    imageKey: "step-12",
  },
  {
    n: 13,
    title: "Gantung power supply",
    description: "Kaitkan power supply ke power pallet di bawah meja.",
    imageKey: "step-13",
  },
  {
    n: 14,
    title: "Sambungkan kabel motor",
    description: "Colokkan kabel yang keluar dari motor di kaki kanan.",
    imageKey: "step-14",
  },
  {
    n: 15,
    title: "Pasang power socket",
    description:
      "Dorong power socket ke lubang di tabletop sampai rata. Standing desk kamu siap dipakai.",
    imageKey: "step-15",
  },
];

export const assemblyTips = [
  "Motornya ada di kaki kanan — power pallet, kabel dan handset semuanya mengarah ke sisi itu.",
  "Luruskan rangka dengan titik penanda di belakang tabletop dulu, baru pasang sekrup.",
  "Biarkan sekrup agak longgar sampai rangkanya siku, baru kencangkan semuanya.",
  "Minta bantuan satu orang untuk membalik meja, supaya tabletop-nya tidak tergores.",
];
